import React from 'react'

function Icon() {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      fill='none'
      viewBox='0 0 24 24'
    >
      <path
        fill='#202020'
        d='M6.811 7.008a7.2 7.2 0 007.936 11.65c.103-.676-.123-1.324-.216-1.55-.207-.505-.89-1.366-2.028-2.56-.304-.32-.284-.565-.175-1.293l.011-.082c.074-.499.198-.794 1.877-1.06.853-.136 1.077.205 1.388.677l.104.155c.295.432.514.531.844.68.149.068.333.153.58.293.587.336.587.715.587 1.544v.095c0 .352-.034.661-.088.93a7.202 7.202 0 00-2.794-11.106c-.498.335-1.181.811-1.42 1.138-.121.167-.294 1.019-.854 1.089a3.3 3.3 0 01-.552-.008c-.56-.036-1.325-.086-1.57.58-.155.42-.183 1.566.32 2.16.082.094.097.27.042.467a.913.913 0 01-.263.448c-.086-.05-.259-.251-.377-.387-.282-.329-.634-.738-1.09-.864-.165-.046-.347-.084-.524-.122-.495-.103-1.053-.221-1.184-.498-.095-.204-.095-.484-.095-.779 0-.375 0-.799-.183-1.21a1.148 1.148 0 00-.276-.387zM12 21a9 9 0 01-9-9 9 9 0 019-9 9 9 0 019 9 9 9 0 01-9 9z'
      ></path>
    </svg>
  )
}

export default Icon
